import React, { useEffect, useState } from 'react';

import { datadogRum } from '@datadog/browser-rum';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { Loader } from '@/components/Loader/loader';
import TunnelResultPage from '@/components/TunnelResultPage/TunnelResultPage';
import { ROUTE } from '@/constants/route';
import { useAuth } from '@/hooks/useAuth';
import { useFaireVersementSucces } from '@/hooks/useFaireVersementSucces';
import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';

export const FaireVersementSucces: React.FC = () => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(true);

  const faireVersementSucces = useFaireVersementSucces();

  useEffect(() => {
    if (user?.id && user?.type && user?.success) {
      TRACKING_INSTANCE.setTcVars({
        page_nom: 'validation versement',
        page_template: 'espace client',
        user_id: user?.id,
        user_client: user?.type === 'Client',
        user_connexion: user?.success,
        user_statut_contrat: sessionStorage.getItem('user_statut_contrat'),
        tunnel_produit: JSON.parse(sessionStorage.getItem('parcoursVersementData') || '{}').contratNomProduit,
        tunnel_metier: 'espace client placement',
        tunnel_sous_metier: JSON.parse(sessionStorage.getItem('parcoursVersementData') || '{}').contratFamille,
        tunnel_categorie_produit: 'parcours de versement',
      });
      void TRACKING_INSTANCE.triggerEvent('page', undefined, {
        event_id: 'page',
        event_categorie: 'affichage espace client',
        event_nom: 'validation versement',
        event_page: 'validation versement',
      });
    }
  }, [user?.id, user?.type, user?.success]);

  useEffect(() => {
    if (token === '') {
      navigate(ROUTE.FAIREVERSEMENTFAIL);
      return;
    }
    faireVersementSucces.mutate(token, {
      onSuccess: (data) => {
        datadogRum.addAction('versement_confirme', { return: data.return });

        setShowLoader(false);
        switch (data.return) {
          case 'success':
            break;

          case 'abandon':
            navigate(ROUTE.FAIREVERSEMENTERROR, { state: { idPlacement: data.placement } });
            break;

          case 'error':
          default:
            navigate(ROUTE.FAIREVERSEMENTFAIL, { state: { idPlacement: data.placement } });
            break;
        }
      },
      onError: () => {
        setShowLoader(false);
        navigate(ROUTE.FAIREVERSEMENTFAIL);
      },
    });
  }, [token, navigate]);

  if (showLoader) return <Loader />;

  return (
    <TunnelResultPage
      iconName="check-circle-solid"
      iconVariant="success"
      title={t('faireVersementSucces.title')}
      subtitles={[t('faireVersementSucces.subtitle')]}
      ctaLabel={t('faireVersementSucces.cta')}
      onCtaClick={() => navigate(ROUTE.DASHBOARD)}
    />
  );
};
